<template>
    <div>
        <el-dialog title="帮助文档" v-if="dialogVisible" :visible.sync="dialogVisible" top="20px" width="80%"
            :before-close="helpClose">
            <!-- <div>
                <el-cascader style="width: 100%;" ref="searchInput" @change="setSearchValue" v-model="searchValue"
                    clearable placeholder="试试搜索：采购" :props="{ expandTrigger: 'hover', emitPath: true }"
                    :options="searchData" filterable></el-cascader>
                <div style="height:500px;overflow-y: auto;" v-html="helpValue"></div>
            </div> -->
            <div style="display: flex;">
                <div style="width: 300px;">
                    <el-input placeholder="输入关键字进行过滤" v-model="filterText" clearable>
                    </el-input>

                    <el-tree class="filter-tree" :data="searchData" :props="defaultProps"
                        :filter-node-method="filterNode" ref="tree" accordion @node-click="handleNodeClick">
                    </el-tree>
                </div>
                <div v-html="helpValue" style="margin-left: 20px;"></div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: 'helpDocument',
        props: [],
        data() {
            return {
                dialogVisible: true,
                searchValue: "",
                searchData: [],
                jurId: '',
                helpValue: '',
                filterText: '',
                defaultProps: {
                    children: 'children',
                    label: 'label'
                }
            }
        },
        watch: {
            filterText(val) {
                this.$refs.tree.filter(val);
            }
        },
        methods: {
            handleNodeClick(data) {
                console.log(data);
                this.jurId = data.jurId
                this.getDocument()
            },
            filterNode(value, data) {
                if (!value) return true;
                return data.label.indexOf(value) !== -1;
            },
            //向父级推送
            helpClose() {
                this.dialogVisible = false
                this.$emit('helpClose', this.dialogVisible)
            },
            // setSearchValue() {
            //     console.log(this.searchValue)
            //     this.jurId = this.searchValue[this.searchValue.length - 1]
            //     this.getDocument()
            // },
            // 根据id查询文档内容
            async getDocument() {
                let params = {
                    ids: [this.jurId]
                }
                var responseData = await this.$http.getDocumentData(params)
                if (responseData.status == 200) {
                    if (responseData.result != null) {
                        this.helpValue = responseData.result.documentData
                    } else {
                        this.helpValue = ''
                    }
                } else {
                    this.$message({
                        message: responseData.message,
                        type: 'error'
                    });
                }
            },
            // 获取权限
            async getJurisdictionList() {
                var dataInfo = this.$store.getters.getUserInfo;
                let responseData = await this.$http.getUserJurisdiction({
                    jurType: 0, //	权限类型权限类型0.erp1.协同
                    opmId: dataInfo.opmId, //	id列表
                })
                if (responseData && responseData.status == 200) {
                    this.searchData = this.handleJurisdictionTwo(responseData.result);
                } else {
                    this.$message({
                        message: responseData.message,
                        type: "error",
                    });
                }
            },
            // 权限处理
            handleJurisdictionTwo(data, id = 0, lev = 0) {
                var son = [];
                data.forEach((value, keys) => {
                    if (lev <= 2) {
                        if (value["jurParentid"] == id) {
                            value["value"] = value["jurId"];
                            value["label"] = value["jurName"];
                            value["lev"] = lev;
                            var list = this.handleJurisdictionTwo(
                                data,
                                value["jurId"],
                                lev + 1
                            );
                            if (list.length >= 1) {
                                value["children"] = this.handleJurisdictionTwo(
                                    data,
                                    value["jurId"],
                                    lev + 1
                                );
                            }
                            son.push(value);
                        }
                    }
                });
                return son;
            },
        },
        created() {
            this.getJurisdictionList()
            this.dialogVisible = true
        },
    }
</script>

<style scoped>
    ::v-deep #taskDialog .el-dialog {
        height: 96%;
        overflow: auto;
        margin-bottom: 0;
    }

    ::v-deep #taskDialog .el-dialog__body {
        height: 82%;
        overflow: auto;
    }

    ::v-deep .el-dialog__body::-webkit-scrollbar {
        /*滚动条整体样式*/
        width: 5px;
        /*高宽分别对应横竖滚动条的尺寸*/
        height: 1px;
    }

    ::v-deep .el-dialog__body::-webkit-scrollbar-thumb {
        /*滚动条里面小方块*/
        border-radius: 10px;
        box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        background: #c1c1c1;
    }

    ::v-deep .el-dialog__body::-webkit-scrollbar-track {
        /*滚动条里面轨道*/
        box-shadow: inset 0 0 5px rgba(255, 255, 255, 1);
        border-radius: 10px;
        background: #f1f1f1;
    }

    #createDialog ::v-deep .el-dialog {
        height: 50%;
    }

    #createDialog ::v-deep .el-form {
        margin-top: 20px;
        margin-bottom: 40px;
    }

    .el-tabs {
        height: 95%;
    }

    ::v-deep .el-tabs__nav-wrap {
        margin-bottom: 0;
    }

    ::v-deep .el-tabs__nav {
        width: 100%;
    }

    ::v-deep .el-tabs__item {
        width: 50%;
        font-size: 20px;
        text-align: center;
    }

    ::v-deep .el-tabs--border-card>.el-tabs__content {
        height: 94%;
        overflow: auto;
    }

    ::v-deep .el-tabs__content::-webkit-scrollbar {
        display: none;
        /* Chrome Safari */
    }

    ::v-deep .el-tabs__content,
    ::v-deep #taskDialog .el-dialog {
        /* 隐藏滚动条 */
        scrollbar-width: none;
        /* firefox */
        -ms-overflow-style: none;
        /* IE 10+ */
    }

    /* ::v-deep .el-card {
    margin-bottom: 20px;
} */

    ::v-deep .el-card:last-child {
        margin-bottom: 8px;
    }

    ::v-deep .el-card__header {
        padding: 0;
    }

    #btnBox {
        padding: 8px 20px;
        color: #409EFF;
        font-weight: 600;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: baseline;
    }

    .tpContentBox {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }

    .tpContentBox .tpContentBoxP2 {
        margin-top: 20px;
        font-size: 6px;
        color: #999;
    }

    .tpContentBox .tpContentBoxP2 .spanMargin {
        margin: 0 2px;
    }

    #btnBox .statusColor {
        font-size: .7rem;
        font-weight: 400;
    }

    .footer {
        margin-top: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    ::v-deep#didia .el-dialog {
        margin-top: 6vh !important;
    }

    ::v-deep#didia .el-dialog__body {
        overflow-x: auto;
        height: 700px;
    }

    /* ::v-deep .ql-align-center {
    text-align: center;
    padding-top: 20px;
} */
    ::v-deep #didia .noticemain h1 {
        text-align: center;
    }

    ::v-deep #didia .noticemain p:nth-child(2) {
        text-align: center;
    }
</style>